const Container = ({ children, className, backgroundImage = true, maxWidth }) => {
  const baseStyle = maxWidth ? {
    maxWidth: '512px',
    margin: '0 auto'
  } : {};

  const combinedStyle = backgroundImage ? {
    ...baseStyle,
    backgroundImage: "url(/assets/background.png)",
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  } : baseStyle;

  return (
    <div
    style={combinedStyle}
    className={`flex flex-col items-center w-full h-full min-h-screen px-6 py-12 md:py-32 ${!backgroundImage ? "bg-darkGray" : ""} ${className || ""}`}
    >
      {children}
    </div>
  )
}

export default Container
